import { useSiteMetadata } from "@hooks/use-site-metadata";
import { SEOPropsModel } from "@models/seo";
import React from "react";

const SEO: React.FunctionComponent<SEOPropsModel> = ({
  title,
  description,
  site_name: siteName,
  crawlable,
  indexable,
  metaTitle: seoMetaTitle,
  keywords,
  pathname = "/",
}) => {
  const siteMetaData = useSiteMetadata();
  const metaTitle = title ?? siteMetaData?.title;
  const metaDescription = description ?? siteMetaData?.description;
  const metaSiteUrl = `${siteMetaData.siteUrl}${pathname}`;
  const enableSEO = process.env.GATSBY_ENABLE_SEO && process.env.GATSBY_ENABLE_SEO === 'true'

  let robotContent = "";
  if (crawlable) {
    robotContent += "follow, ";
  } else {
    robotContent += "nofollow, ";
  }

  if (indexable) {
    robotContent += "index, ";
  } else {
    robotContent += "noindex, ";
  }

  if(!enableSEO) return <></>

  return (
    <>
      <html lang="en" />
      <title>{metaTitle}</title>
      <meta charSet="utf-8" />
      <meta
        id="viewport"
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta
        name="robots"
        content={`${robotContent} max-image-preview:large, max-snippet:-1, max-video-preview:-1`}
      />
      <meta httpEquiv="x-ua-compatible" content="ie=edge" />
      <meta name="description" content={metaDescription} />
      <meta name="twitter:title" content={metaSiteUrl} />
      <meta name="twitter:site" content="@Unbxd" />
      <meta name="keywords" content={keywords}></meta>

      <meta property="og:type" content="website"></meta>
      <meta property="og:title" content={seoMetaTitle ?? metaTitle}></meta>
      <meta property="og:description" content={metaDescription}></meta>
      <meta property="og:url" content={metaSiteUrl}></meta>
      <meta property="og:site_name" content={siteName ?? metaTitle}></meta>
    </>
  );
};
export default SEO;
